export enum MediaTypes {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
    INTERNAL = 'INTERNAL',
    PRX_INTERNAL = 'PRX_INTERNAL'
}